import { Expose } from "class-transformer";

export class LeadRankConfig {
  @Expose()
  id: string;

  @Expose()
  leadRankThreshold: number;

  @Expose()
  version: number;

  @Expose()
  createdTs: Date;

  @Expose()
  updatedTs: Date;
}
